<template>
  <v-card :class="{ 'full-height': isSegmentationWithoutRfv }">
    <mf-loading
      :class="{ 'full-height': isSegmentationWithoutRfv }"
      loader="evaluate-segmentation"
      loader-type="dynamic"
      :dynamic-amount="3"
      :dynamic-width="isSegmentationWithoutRfv ? 200 : 1200"
    >
      <v-row class="pl-5 pr-6 justify-space-between">
        <v-col :cols="isSegmentationWithoutRfv ? '12' : '2'" class="d-flex align-center pl-1" :class="{ 'width-fit-content': !isSegmentationWithoutRfv }">
          <div>
            <v-row no-gutters>
              <v-col class="py-0">
                <span class="texto-corrido text-no-wrap">Tamanho do segmento</span>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="py-2">
                <span class="medium-number">{{ showSegmentationSize ? segmentationSize.clients_qty : 0 | localeString }}</span>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="py-0">
                <span class="texto-corrido">{{ showSegmentationSize ? percent : 0 }}% dos {{ qtdeCadastrados | localeString }} clientes</span>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <v-col v-if="!isSegmentationWithoutRfv" cols="2" class="d-flex align-center width-fit-content mr-0" style="min-width: 275px">
          <div class="separator-border-card"></div>
          <div>
            <v-row>
              <v-col class="py-0">
                <span class="title-card">Distribuição na Classificação RFV</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="rfvPeriod" class="py-0">
                <mf-tooltip variant="secondary" top max-width="300">
                  <template v-slot:activator>
                    <span class="body-card">Últimos 90 dias</span>
                  </template>
                  {{ rfvPeriod }}
                </mf-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0 pt-1">
                <mf-toggle :value="autoUpdateSegmentInsights" label="Atualizar automaticamente" hide-details @input="setAutoUpdateSegmentInsights" />
              </v-col>
            </v-row>
          </div>
        </v-col>

        <v-col v-for="(cluster, index) of mainRFVClusters" :key="`cluster-${index}`" cols="1" class="px-0 d-flex align-center width-fit-content">
          <div :style="{ borderColor: cluster.color, height: '67px' }" class="pl-2 mr-3 virtual-border-card">
            <v-row fill-height>
              <v-col class="py-0">
                <span>{{ cluster.icon }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <span class="no-wrap text-cluster text-no-wrap">
                  {{ cluster.label }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">{{ cluster.value | localeString }}</v-col>
            </v-row>
          </div>
        </v-col>
        <v-col
          v-if="!isSegmentationWithoutRfv"
          cols="3"
          class="px-0 d-flex align-center width-fit-content ml-2"
          style="clip-path: fill-box; min-width: max-content"
        >
          <v-row fill-height>
            <v-col cols="6" class="py-0 d-flex align-center width-fit-content">
              <div :style="{ borderColor: '#B3280D' }" class="pl-3 virtual-border-card">
                <v-row v-for="(cluster, index) of secondaryRFVClusters" :key="`secondary-cluster-${index}`" no-gutters>
                  <mf-tooltip v-if="cluster.tooltip" max-width="300" top variant="secondary">
                    <template #activator="{ on }">
                      <span class="cluster-area-text text-no-wrap" v-on="on">
                        <mf-icon small>info</mf-icon>
                        <span class="cluster-label text-no-wrap"> {{ cluster.label }}: </span>
                        <span class="cluster-value text-no-wrap">
                          {{ cluster.value | localeString }}
                        </span>
                      </span>
                    </template>
                    {{ cluster.tooltip }}
                  </mf-tooltip>
                  <span v-else class="cluster-area-text text-no-wrap">
                    <span class="cluster-label text-no-wrap"> {{ cluster.label }}: </span>
                    <span class="cluster-value text-no-wrap">
                      {{ cluster.value | localeString }}
                    </span>
                  </span>
                </v-row>
              </div>
            </v-col>
            <v-col cols="6" class="py-0 d-flex align-center width-fit-content align-self-end">
              <div>
                <span
                  v-if="!loadingSaveSegmentation"
                  class="link link-rfv-text"
                  :class="{ 'link-rfv-disabled': disableSaveSegmentation }"
                  @click="confirmAndRouteToRFV"
                  >Explorar RFV</span
                >
                <span v-else>
                  <mf-icon class="link-rfv-icon">processing</mf-icon>
                </span>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div v-if="isSegmentInsightsStale && !isSegmentationWithoutRfv" class="overlay-content">
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center">
            <v-col class="text-center">
              <mf-button :loading="loadingSegmentInsights" label="Atualizar Insights" @click="localCalculateSegmentInsights" />
            </v-col>
          </v-row>
        </v-container>
      </div>
    </mf-loading>
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import floor from 'lodash/floor'

export default {
  components: {},
  props: {
    disableSaveSegmentation: {
      type: Boolean,
      default: false,
    },
    saveSegmentation: {
      type: Function,
      default: () => {},
    },
    loadingSaveSegmentation: {
      type: Boolean,
      default: false,
    },
    isIndustry: {
      type: Boolean,
      default: false,
    },
    segment: {
      type: Object,
      default: () => ({}),
    },
    isSegmentationWithoutRfv: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loadingSegmentInsights: false,
  }),
  computed: {
    ...mapGetters({
      showSegmentationSize: 'showSegmentationSize',
      primeiroRegistro: 'empresaPrimeiroRegistro',
    }),
    ...mapState({
      autoUpdateSegmentInsights: (state) => state.segmentation.autoUpdateSegmentInsights,
      segmentationSize: (state) => state.segmentation.segmentationSize,
      segmentationRFVClusters: (state) => state.segmentation.segmentationRFVClusters,
      qtdeCadastrados: (state) => state.clientes.quantidadeClientesCadastrados,
      isSegmentInsightsStale: (state) => state.segmentation.isSegmentInsightsStale,
      segmentationGroups: (state) => state.segmentation.segmentationGroups,
    }),

    percent() {
      if (!this.existCriteriaAndIsValid && !this.segmentationSize) return 0
      return floor((this.segmentationSize.clients_qty / this.qtdeCadastrados) * 100, 2)
    },

    rfvPeriod() {
      if (!this.segmentationRFVClusters?.analytic_period) return ''
      const initialDate = DateTime.fromFormat(this.segmentationRFVClusters.analytic_period.initial_date, 'yyyy-MM-dd').toFormat('dd/MMM/yyyy')
      const finalDate = DateTime.fromFormat(this.segmentationRFVClusters.analytic_period.final_date, 'yyyy-MM-dd').toFormat('dd/MMM/yyyy')

      return `${initialDate} - ${finalDate}`
    },

    mainRFVClusters() {
      if (this.isSegmentationWithoutRfv) return []
      return [
        {
          icon: '🏆',
          label: 'Campeões',
          color: '#D4FF00',
          value: this.segmentationRFVClusters?.valid ? this.segmentationRFVClusters?.clusters?.champions ?? 0 : '-',
        },
        {
          icon: '🎖️',
          label: 'Clientes leais',
          color: '#31D472',
          value: this.segmentationRFVClusters?.valid ? this.segmentationRFVClusters?.clusters?.loyals ?? 0 : '-',
        },
        {
          icon: '🚀',
          label: 'Promissores',
          color: '#54AAFF',
          value: this.segmentationRFVClusters?.valid ? this.segmentationRFVClusters?.clusters?.promising ?? 0 : '-',
        },
        {
          icon: '❗',
          label: 'Em risco',
          color: '#FFC34E',
          value: this.segmentationRFVClusters?.valid ? this.segmentationRFVClusters?.clusters?.at_risk ?? 0 : '-',
        },
        {
          icon: '👎',
          label: 'Baixo Valor',
          color: '#FF7459',
          value: this.segmentationRFVClusters?.valid ? this.segmentationRFVClusters?.clusters?.low_value ?? 0 : '-',
        },
      ]
    },
    secondaryRFVClusters() {
      return [
        {
          label: 'Perdidos',
          value: this.segmentationRFVClusters?.valid ? this.segmentationRFVClusters?.clusters?.losses ?? 0 : '-',
        },
        {
          label: 'Nunca compraram',
          value: this.segmentationRFVClusters?.valid ? this.segmentationRFVClusters?.clusters?.never_bought ?? 0 : '-',
        },
        {
          label: 'Não fidelidade',
          value: this.segmentationRFVClusters?.valid ? this.segmentationRFVClusters?.clusters?.non_loyalty ?? 0 : '-',
        },
      ]
    },
  },
  mounted() {
    this.quantidadeClientesCadastrados()
    if (this.isSegmentationWithoutRfv) this.setAutoUpdateSegmentInsights(true)
  },
  methods: {
    ...mapActions([
      'quantidadeClientesCadastrados',
      'setIsSegmentStale',
      'setAutoUpdateSegmentInsights',
      'setQuickAction',
      'calculateSegmentSize',
      'calculateSegmentSizeAndRFVClusters',
    ]),
    async confirmAndRouteToRFV() {
      const confirmed = await this.$confirm({
        message: 'Para analisar o segmento na tela de Classificação RFV o segmento será salvo com a configuração atual. Deseja prosseguir?',
        confirmText: 'Continuar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      let segment = {}
      if (!this.isIndustry) {
        segment = await this.saveSegmentation({ redirect: false })
      } else {
        segment = this.segment
      }
      this.setQuickAction({ segmentation: { segment, title: this.segment.name, description: this.segment.description } })
      const newTab = this.$router.resolve({ path: '/clientes/classificacao-rfv', query: { quick_action: true } })
      window.open(newTab.href, '_blank')
    },
    async localCalculateSegmentInsights() {
      this.loadingSegmentInsights = true
      try {
        if (this.isSegmentationWithoutRfv) {
          await this.calculateSegmentSize()
        } else {
          await this.calculateSegmentSizeAndRFVClusters()
        }
        this.setIsSegmentStale(false)
      } catch (e) {
        console.warn('Failed to calculate segment insights', e)
        this.$snackbar({ message: `Falha ao calcular insights do segmento`, snackbarColor: 'error' })
      }

      this.loadingSegmentInsights = false
    },
  },
}
</script>

<style lang="scss" scoped>
.full-height {
  height: 100%;
}
.emoji-container {
  width: 28px;
  height: 28px;
  font-size: 16px;
  border-radius: 8px;
}
@media (min-width: 1700px) {
  .no-wrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.width-fit-content {
  max-width: fit-content;
}
.overlay-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7); /* Semi-transparent white */
  backdrop-filter: blur(2px); /* Optional blur effect */
  z-index: 3; /* Ensure overlay is above the card content */
}
.separator-border-card {
  height: 90%;
  border-left: 2px solid #6b7580;
  margin-left: -8px;
  margin-right: 16px;
}
.title-card {
  color: #00366d;
}
.body-card {
  font-size: 14px;
}
.text-cluster {
  font-size: 12px;
  font-weight: 700;
  line-height: 14.4px;
  letter-spacing: 0.01em;
}
.cluster-area-text {
  margin: 0 0 2px 0;
  min-inline-size: max-content;
  display: inline-flex;
  gap: 4px;
  align-items: center;
}
.cluster-label {
  color: $cinza-d10;
  font-size: 12px;
  font-weight: 700;
  line-height: 14.4px;
  letter-spacing: 0.01em;
}
.cluster-value {
  color: #721200;
  font-size: 14px;
  font-weight: 700;
  line-height: 16.8px;
  letter-spacing: 0.01em;
}
.virtual-border-card {
  border-radius: 0px 4px 0px 0px;
  border-left: 3px solid;
  height: 68px;
}
.medium-number {
  font-size: 22px;
  font-weight: 700;
  line-height: 26.4px;
  letter-spacing: 0.01em;
  text-align: center;
}
.link-rfv-text {
  white-space: nowrap;
  display: flex;
  align-items: baseline;
}
.link-rfv-icon {
  color: #0079f2 !important;
  text-decoration: underline;
  font-size: 14px !important;
}

.link-rfv-disabled {
  color: #afafaf !important;
  cursor: not-allowed !important;
  pointer-events: none;
}
</style>
